import React from "react";
import { useEffect } from "react";
import { AuthRestartButton } from "../misc/restart-button.component";
import { AuthPaymentContainer } from "../misc/auth-payment-container.component";
import { AuthContinue } from "../misc/auth-continue.component";
import { ReviewDisplayField } from "../misc/review-display-field.component";
import payoffMessage from "../misc/payoff-message.component";
import Show from "../../../utils/show.component";
import { formatLastFour, generateLoanDescription } from "../misc/messaging-utils";

export const AuthInternalTransferReview = (props) => {
  const advance = () => {
    window.scrollTo(0, 0);

    props.callAuthSubmitInternalPayment(props.selectedLoan.IsCreditOrExternalAccount);
  };

  useEffect(() => {
    // If the payment response has this property, that means there were no errors
    // submitting the payment and the paymentResponse property has been set
    if (props.paymentResponse.hasOwnProperty("AmountDue")) {
      props.setProcessStep(3);
    }
  }, [props.paymentResponse]);

  return (
    <AuthPaymentContainer title="Review & Submit">
      <div className="text-centered bold f20">
        {`${generateLoanDescription(props.selectedLoan, true)}`}
      </div>
      <div className="my-4 divider"></div>
      <div>
        <ReviewDisplayField title={"Payment Applied Date"} value={props.paymentAppliedDate} />
        <ReviewDisplayField
          title={"Payment Account"}
          value={`${props.paymentAccount.AccountType} (${props.paymentAccount.AccountLastFour})`}
          valueClassNames={"minwidth-fit"}
          titleColumnSize={"col-md-6"}
          valueColumnSize={"col-md-6"}
        />
        <ReviewDisplayField title={"Payment Amount"} value={props.paymentAmount} />
      </div>
      <Show condition={props.isPayoff}>{payoffMessage(props.paymentAppliedDate)}</Show>
      {/* <div className="f12 italic">
            Disclosure will go here.
          </div> */}
      <AuthContinue
        type="button"
        title={props.isPayoff ? "Pay Off My Loan" : "Submit Payment"}
        onClickFunction={() => advance()}
      />
      <AuthRestartButton backToLoans={props.backToLoans} />
    </AuthPaymentContainer>
  );
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/review/auth-internal-transfer-review-fields.component.js